import { Box, BoxProps } from '@mui/material';
import { m, MotionProps } from 'framer-motion';
import { varFadeInUp } from './variants';

type Props = BoxProps & MotionProps;

interface TextAnimateProps extends Props {
  text: string;
}

export function TextAnimate({ text, variants, sx, ...other }: TextAnimateProps) {
  return (
    <Box
      component={m.div}
      sx={{
        m: 0,
        typography: 'h1',
        overflow: 'hidden',
        display: 'inline-flex',
        ...sx
      }}
      {...other}
    >
      {text.split('').map((letter, index) => (
        <m.span key={index} variants={variants || varFadeInUp}>
          {letter}
        </m.span>
      ))}
    </Box>
  );
}
